import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllUsers = createAsyncThunk(
    'user/getAllUsers',
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search !== '') params.search = search;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/users`, config);
            console.log(response)
            return response.data
        } catch (error) {
            console.log(error)
            if (error.message === 'Network Error') {
                return rejectWithValue({
                    response: {
                        data: {
                            message: 'Network Error',
                            status: error.code,
                        }
                    }
                });
            } else {
                return rejectWithValue({
                    message: 'Error',
                    status: error.code,
                });
            }
        }
    }
);

export const editUser = createAsyncThunk(
    'user/editUser',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/users/update-user-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);